const GrupoMMParticular2 = [
    {
        "tipoVenta": "ALTA_NUEVA",
        "tipoLinea": "LINEA_ADICIONAL",
        "tarifa": {
            "id": "PPOSCONVERGENTGRUPOMM10",
            "price": 41.2397,
            "name": "Fibra 600 Indirecta + Mas 25 GB",
            "operator": "GRUPO MM",
            "segment": "PARTICULAR",
            "category": "convergent",
            "color": null,
            "commercial_enrichment": null,
            "description_file": null,
            "fixed_line_info": {
                "type": "",
                "owners": [],
                "upload_speed": {
                    "unit": "Mb",
                    "amount": 0
                },
                "download_speed": {
                    "unit": "Mb",
                    "amount": 0
                },
                "voice_to_fixed": {
                    "unit": "min",
                    "amount": 0
                },
                "voice_to_mobile": {
                    "unit": "min",
                    "amount": 0
                }
            },
            "mobile_line_info": {
                "mobile_line_data": {
                    "unit": "GB",
                    "amount": 0
                },
                "mobile_line_voice": {
                    "unit": "min",
                    "amount": 0
                }
            },
            "payment_type": "postpaid",
            "is_active": true,
            "created_on": "2022-05-25T00:45:13.938041+02:00",
            "updated_on": "2022-05-25T00:45:13.946057+02:00",
            "svas": [],
            "promotions": [
                "PROMOGRUPOMM3",
                "PROMOGRUPOMM7",
                "PROMOGRUPO_MM3",
                "PROMOGRUPO_MM10"
            ],
            "additional_lines": [
                "PMAS25GBADGRUPOMM",
                "PMAS5GBADGRUPOMM",
                "PMAS8GBADGRUPOMM",
                "PMASEXTRA3GBGRUPOMM"
            ]
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": [
            {
                "id": "PROMOGRUPO_MM3",
                "duration": 3,
                "name": "F600 a precio de F100 MM",
                "duration_unit": "month",
                "amount": "10.00",
                "amount_unit": "MONETARY",
                "is_active": true,
                "observations": null,
                "operator": "GRUPO MM"
            }
        ]
    }
]
export default GrupoMMParticular2;